import { Component, OnInit, ChangeDetectionStrategy, Input, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { getProductsByQuery, LoadProductsByQuery, Product } from 'src/app/shop';
import { ContentBlock, ProductPreview } from '../../models';
import { FilterProductsNotFoundPipe } from '../../pipes/filter-products-not-found.pipe';
import { NgClass, AsyncPipe } from '@angular/common';
import { ProductCardComponent } from '../../../catalog/components/product-card/product-card.component';
import { LinkComponent } from '@teamfoster/sdk/button';

@Component({
  selector: 'app-content-block-featured-products',
  templateUrl: './content-block-featured-products.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, ProductCardComponent, LinkComponent, AsyncPipe],
})
export class ContentBlockFeaturedProductsComponent implements OnInit {
  private store = inject(Store);

  @Input() block!: ContentBlock;
  productsSections$!: Observable<{ [key: string]: Product[] }>;
  products$: Observable<Product[]> = of([]);

  //loadedProductSections$: Observable<string[]> = of([]);

  loadedFromShopify = false;
  private filterNotFound = new FilterProductsNotFoundPipe();

  ngOnInit(): void {
    const searchQuery = this.block.featuredProducts?.map((a: ProductPreview) => `(id:${a.productId})`).join(' OR ');
    if (searchQuery) {
      this.store.dispatch(LoadProductsByQuery({ searchQuery, identifier: `${this.block.blockType}-${this.block.id}` }));
    }

    this.productsSections$ = this.store.select(getProductsByQuery);
    this.products$ = this.productsSections$.pipe(
      switchMap(sections => of(sections[this.getSectionIdentifier(this.block)])),
      tap(a => (this.loadedFromShopify = true)),
      map(products => products?.sort((a, b) => (this._getProduct(a.id)?.order || 0) - (this._getProduct(b.id)?.order || 0)))
    );
  }

  getSectionIdentifier(block: ContentBlock): string {
    return `${block.blockType}-${block.id}`;
  }

  private _getProduct(id: string) {
    return this.block.featuredProducts?.find(a => id.includes(a.productId));
  }

  get filteredProducts$(): Observable<ProductPreview[]> {
    if (!this.block?.featuredProducts) {
      return of([]);
    }
    return this.products$.pipe(
      map(a => {
        return this.filterNotFound.transform(this.block.featuredProducts || [], this.loadedFromShopify, a);
      })
    );
  }
}
